'use client'

import { twMerge } from '@/lib/classname/twMerge'

type RadioBulletProps = {
  isSelected: boolean
  isInvalid?: boolean
  isDisabled?: boolean
  className?: string
  'data-testid'?: string
}

// Shared bullet: ring + inner dot, used by RadioButton and RadioCard so both stay visually aligned instead of each keeping its own chip variant
export function RadioBullet({
  isSelected,
  isInvalid,
  isDisabled,
  className,
  'data-testid': dataTestId,
}: RadioBulletProps) {
  const dotColor = isInvalid ? 'bg-error-fg' : isDisabled ? 'bg-brand-2-400' : 'bg-grey-700'

  return (
    <span
      aria-hidden
      data-testid={dataTestId}
      className={twMerge(
        'box-border block size-2 shrink-0 rounded-full border-px bg-white hd:border-1.5',
        isDisabled ? 'border-brand-2-400' : isInvalid ? 'border-error-fg' : 'border-brand-2-200',
        isSelected && !isDisabled && !isInvalid && 'border-grey-700',
        className,
      )}
    >
      <span
        aria-hidden
        className={twMerge(
          'block size-full rounded-full border-2 border-white',
          isSelected && dotColor,
        )}
      />
    </span>
  )
}
